interface FieldProps {
  label: string;
  children: React.ReactNode;
  htmlFor: string;
  error?: string;
  required?: boolean;
  className?: string;
}

export const Field = ({ label, children, htmlFor, error, required, className }: FieldProps) => {
  return (
    <div className="space-y-1">
      <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span>*</span>}
      </label>
      <div className={className}>{children}</div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};
